import * as React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';
import {
  ContainerProcedure,
  ButtonBack
} from '../../ChangeCareerCampusModality/info/components';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import { Block } from '@/presentation/components';
import Step from '../../UpdatePhoto/Register/components/Step';
import IDHelpers from '@/core/helpers/IDHelper';
import { allFields } from '../register/types';
import Spinner from '@/presentation/components/Spinner';
import StepConstancy from '../../CertificateOfStudies/steps/Constancy';

const EmployabilityCharterProgressViewController = () => {
  const { push } = useHistory();

  const {
    procedure,
    request
    // isLoading: isLoadingProcedureStatus
  } = useSelector((state: any) => state.procedureStudentStatus);

  if (!procedure) {
    return <Spinner />;
  }
  const statusValue = request.status.status;
  const statusMap = {
    pending: [
      'PENDIENTE',
      'CREADO',
      'PAGO_ACTIVADO',
      'PENDING_PROGRESS',
      'PENDING_PAY',
      'PENDING_ATTENTION',
      'PENDING_MODIFY',
      'REGULARIZACION',
      'POR_ATENDER',
      'EN_PROCESO',
      'PEND_PROCESO'
    ].includes(statusValue),
    paymentMade: statusValue === 'PAGO_REALIZADO',
    notProceed: ['NO_PROCEDE', 'FINALIZED_UNSUCCESS'].includes(statusValue),
    canceled: request.status.status === 'ANULADO',
    processed: ![
      'PENDIENTE',
      'CREADO',
      'PAGO_ACTIVADO',
      'PENDING_PROGRESS',
      'PENDING_PAY',
      'PENDING_ATTENTION',
      'PENDING_MODIFY',
      'REGULARIZACION',
      'POR_ATENDER',
      'EN_PROCESO',
      'PEND_PROCESO',
      'PAGO_REALIZADO',
      'NO_PROCEDE',
      'FINALIZED_UNSUCCESS',
      'ANULADO'
    ].includes(statusValue)
  };

  return (
    <div data-testid="cmp-employabilityCharterView">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={() => push('/tramites')} />
        </SubContainer>
        <SubContainer>
          <ToggleHeader
            status={request.status}
            inRegister
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            childContent={<ProcedureInfoComponent pin1={procedure?.pin1} />}
            twoLineFormat
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              name={procedure?.steps[0]?.name}
              order={procedure?.steps[0]?.order}
              isComplete
            >
              <span style={{ fontSize: 12 }}>Resumen</span>
              <ul style={{ marginLeft: 14, fontSize: 12 }}>
                {Object.keys(
                  procedure?.detail?.employabilityCharterDetail
                )?.map((k) => (
                  <>
                    {allFields[k] &&
                    procedure?.detail?.employabilityCharterDetail[k] &&
                    procedure?.detail?.employabilityCharterDetail[k] !== '0' ? (
                      <li
                        style={{ listStyle: 'initial' }}
                        key={IDHelpers.generateID()}
                      >
                        {allFields[k]}:{' '}
                        {procedure?.detail?.employabilityCharterDetail[k]}
                      </li>
                    ) : null}
                  </>
                ))}
              </ul>
            </Step>
            <Step
              name={procedure?.steps[1]?.name}
              order={procedure?.steps[1]?.order}
              isComplete={statusMap.processed || statusMap.notProceed}
              isLast
            >
              <span
                style={{ fontSize: 12, marginBottom: 12, display: 'block' }}
              >
                Fecha de solicitud: {procedure?.steps[1].date?.toLowerCase()}
              </span>
              <StepConstancy
                active
                status={statusValue}
                option={
                  statusMap.pending
                    ? 0
                    : statusMap.processed
                    ? 1
                    : statusMap.notProceed
                    ? 3
                    : 2
                }
                document={
                  procedure?.detail?.employabilityCharterDetail?.documentPath
                }
                dateOfPayment=""
                fileName={
                  procedure?.detail?.employabilityCharterDetail?.charterDesc
                }
                title={
                  statusMap.processed
                    ? 'Tu carta está lista'
                    : statusMap.pending
                    ? 'Tu solicitud está en proceso'
                    : statusMap.notProceed
                    ? 'Tu solicitud no procede'
                    : 'Tu solicitud ha sido cancelada'
                }
                deprecated={request?.expiredFile}
              />
            </Step>
          </Block>
        </SubContainer>
      </ContainerProcedure>
    </div>
  );
};

export default EmployabilityCharterProgressViewController;
